module.exports = __webpack_public_path__ + "static/media/holiday2.500256c2.gif";